import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, XCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const UnsubscribePage = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!email) {
      setStatus('error');
      return;
    }
    axios.get(`${API}/unsubscribe?email=${encodeURIComponent(email)}`)
      .then((res) => {
        if (res.data.message?.includes('not found')) {
          setStatus('not_found');
        } else {
          setStatus('success');
        }
      })
      .catch(() => setStatus('error'));
  }, [email]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-zinc-50">
      <div className="text-center max-w-md mx-auto px-4">
        {status === 'loading' && (
          <p className="text-zinc-500">Processing your request...</p>
        )}
        {status === 'success' && (
          <>
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle2 className="w-10 h-10 text-green-600" />
            </div>
            <h1 className="text-3xl font-black text-zinc-900 mb-4">Unsubscribed</h1>
            <p className="text-zinc-600 mb-8">
              <strong>{email}</strong> has been removed from our mailing list. You will no longer receive load notifications.
            </p>
            <Link to="/" className="inline-flex items-center bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-bold uppercase tracking-wide transition-colors">
              Go to Homepage
            </Link>
          </>
        )}
        {status === 'not_found' && (
          <>
            <div className="w-20 h-20 bg-zinc-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle2 className="w-10 h-10 text-zinc-400" />
            </div>
            <h1 className="text-3xl font-black text-zinc-900 mb-4">Already Unsubscribed</h1>
            <p className="text-zinc-600 mb-8">
              This email is not on our mailing list or was already unsubscribed.
            </p>
            <Link to="/" className="inline-flex items-center bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-bold uppercase tracking-wide transition-colors">
              Go to Homepage
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-10 h-10 text-red-600" />
            </div>
            <h1 className="text-3xl font-black text-zinc-900 mb-4">Something Went Wrong</h1>
            <p className="text-zinc-600 mb-8">
              We couldn't process your unsubscribe request. The email may already be unsubscribed or not found.
            </p>
            <Link to="/" className="inline-flex items-center bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-bold uppercase tracking-wide transition-colors">
              Go to Homepage
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default UnsubscribePage;
